import {
  useAddBudgetFormModalContext,
  useIncidentDetailContext,
  useUserLanguage,
} from '@/customHooks'
import { capitalizeFirstLetter } from '@/helpers'
import { ButtonWithDropDownMenu } from '../molecules'
import { BudgetStatusPill, Button, RowSpacer } from '../atoms'
import { AddBudgetFormModal } from '../templates'

const textsData = {
  en: {
    subject: 'Subject',
    cost: 'Cost',
    supplier: 'Supplier',
    status: 'Budget Status',
    noData: 'No budgets created yet',
    dropdownMenu: {
      deatils: 'Details',
      edit: 'Edit',
    }
  },
  es: {
    subject: 'Asunto',
    cost: 'Costo',
    supplier: 'Proveedor',
    status: 'Estado del presupuesto',
    noData: 'No hay algún presupuesto creado aún',
    dropdownMenu: {
      deatils: 'Detalles',
      edit: 'Editar',
    }
  }
}

export const BudgetDetailList = () => {
  const userLanguage = useUserLanguage()
  const texts = userLanguage === 'es' ? textsData.es : textsData.en

  const { incident } = useIncidentDetailContext()
  const budgets = incident?.budgets

  const { openModal } = useAddBudgetFormModalContext()

  return (
    <>
      <RowSpacer height={1} />
      <div className="flex justify-end">
        <Button
          onClick={() => openModal()}
        >
          + Add Budget
        </Button>
      </div>
      {
        !budgets || budgets.length === 0
          ? <p className="mt-4"><b>{texts.noData}</b></p>
          : (
            <div className="w-full overflow-x-auto rounded-xl border border-[var(--color-border)] bg-white py-4">
              <div className="min-w-[640px]">
                <div className="grid grid-cols-[1fr_1fr_1fr_1fr_64px] border-b border-gray-300 font-bold">
                  <div className="px-4 py-3 text-left">{texts.subject}</div>
                  <div className="px-4 py-3 text-left">{texts.supplier}</div>
                  <div className="px-4 py-3 text-left">{texts.cost}</div>
                  <div className="px-4 py-3 text-left">{texts.status}</div>
                  <div className="px-4 py-3" />
                </div>
                {budgets?.map((data, index) => (
                  <div
                    key={data.id}
                    className={`grid grid-cols-[1fr_1fr_1fr_1fr_64px] text-sm ${index % 2 !== 0 ? 'bg-background2' : 'bg-white'}`}
                  >
                    <div className="flex items-center px-4 py-4">{capitalizeFirstLetter(data.subject)}</div>
                    <div className="flex items-center px-4 py-4">{capitalizeFirstLetter(`${data.supplier.firstName} ${data.supplier.lastName}`)}</div>
                    <div className="flex items-center px-4 py-4">{data.budgetCost}</div>
                    <div className="flex items-center px-4 py-4"><BudgetStatusPill option={data.budgetStatusOption} /></div>
                    <div className="flex items-center justify-end px-4 py-4">
                      <ButtonWithDropDownMenu
                        options={[
                          { item: texts.dropdownMenu.edit, action: () => openModal({ ...data, observation: '' }) },
                        ]}
                        position='left'
                      />
                    </div>
                  </div>
                )) ?? null}
              </div>
            </div>
          )
      }
      <AddBudgetFormModal />
    </>
  );
};
